import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from './store/types'
import { NxCentralizedLoading } from './components/loading'
import { Router } from './features/router'
import { initializeAuth } from './features/auth'
import { initializeMfes } from './features/mfe'
import './global.css'
import { ToastContextProvider } from '@celebration/react'

const App: FC = (): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>()

  const isAuthInitialized = useSelector((state: RootState) => state.auth.initialized)
  const areMfesInitialized = useSelector((state: RootState) => state.mfe.initialized)

  useEffect(() => {
    dispatch(initializeAuth())
      .unwrap()
      .then(() => dispatch(initializeMfes()))
  }, [dispatch])

  return isAuthInitialized && areMfesInitialized ? (
    <ToastContextProvider>
      <Router />
    </ToastContextProvider>
  ) : (
    renderLoading()
  )
}

const renderLoading = (): React.ReactElement => {
  return (
    <div style={{ height: '100dvh' }}>
      <NxCentralizedLoading ariaLabel='Carregando...' />
    </div>
  )
}

export default App
